//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BISAP',
  components: {},
  data () {
    return {
      form: {
        bun: '0',
        glasgow: '0',
        inflammation: '0',
        age: '0',
        pleuralEffusion: '0'
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.bun + form.glasgow + form.inflammation + form.age + form.pleuralEffusion
      self.hasScore = true
      if (result < 3) {
        self.descTxt = '死亡率低（＜2%）'
      } else if (result > 2) {
        self.descTxt = '死亡率高（＞15%）'
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/BISAP.vue